import {Injectable} from '@angular/core';
import { I18nService } from '../../shared/i18n';


declare var $: any;

@Injectable()
export class NotificationService {
  private colorWarning = '#C79121';
  private colorSuccess = '#06AC6D';
  private colorError = '#71071B';
  private colorInfo = '#3276B1';
  private timeDefault = 5000;

  constructor(
    private i18nService: I18nService
  ) {}

  public smallBox(data, cb?) {
    $.smallBox(data, cb);
  }

  public smallBoxOK(title: string, content: string, cb?) {
    this.smallBox({
          title: title,
          content: content,
          color: this.colorSuccess,
          iconSmall: 'fa fa-check-circle bounce animated',
          timeout: this.timeDefault
        });
  }

  public smallBoxWarning(title: string, content: string, cb?) {
    this.smallBox({
          title: title,
          content: content,
          color: this.colorWarning,
          iconSmall: 'fa fa-info-circle bounce animated',
          timeout: this.timeDefault
        });
  }

  public smallBoxError(content: string, cb?) {

    this.smallBox({
          title: 'Ventana de Alerta!',
          content: content,
          color: this.colorError,
          iconSmall: 'fa fa-exclamation-triangle bounce animated',
          timeout: this.timeDefault
        });
  }

  localErrorMessage(keyMessage: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.error'),
      content: this.i18nService.getTranslation(keyMessage),
      color: this.colorError,
      iconSmall: 'fa fa-exclamation-triangle bounce animated',
      timeout: this.timeDefault
    });
  }

  localWarningMessage(keyMessage: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.warning'),
      content: this.i18nService.getTranslation(keyMessage),
      color: this.colorWarning,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  localInfoMessage(keyMessage: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.info'),
      content: this.i18nService.getTranslation(keyMessage),
      color: this.colorInfo,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  localSuccessMessage(keyMessage: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.success'),
      content: this.i18nService.getTranslation(keyMessage),
      color: this.colorSuccess,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  serverErrorMessage(message: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.error'),
      content: message,
      color: this.colorError,
      iconSmall: 'fa fa-exclamation-triangle bounce animated',
      timeout: this.timeDefault
    });
  }

  serverWarningMessage(message: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.warning'),
      content: message,
      color: this.colorWarning,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  serverInfoMessage(message: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.info'),
      content: message,
      color: this.colorInfo,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  serverSuccessMessage(message: string) {
    this.smallBox({
      title: this.i18nService.getTranslation('Message.title.success'),
      content: message,
      color: this.colorSuccess,
      iconSmall: 'fa fa-info-circle bounce animated',
      timeout: this.timeDefault
    });
  }

  bigBox(data, cb?) {
    $.bigBox(data, cb)
  }

  smartMessageBox(data, cb?) {
    $.SmartMessageBox(data, cb)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts